import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("b360_cookies")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("b360_cookies", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-24 left-4 right-4 z-50 border border-black/10 bg-white p-5 shadow-[0_8px_40px_rgba(0,0,0,0.12)] sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md"
          role="dialog"
          aria-label="Consentement aux cookies"
        >
          <p className="text-sm leading-relaxed text-bati-ink/80">
            Nous utilisons des cookies pour mesurer l'audience du site et améliorer votre expérience. Vous pouvez accepter ou refuser leur utilisation.
          </p>
          <div className="mt-4 flex items-center gap-3">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="bg-bati-blue px-5 py-2.5 text-xs font-bold uppercase tracking-[0.1em] text-white transition-colors duration-300 hover:bg-bati-sky"
            >
              Accepter
            </button>
            <button
              data-testid="cookie-decline-button"
              onClick={() => choose("refused")}
              className="border border-black/15 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.1em] text-bati-ink transition-colors duration-300 hover:border-bati-ink"
            >
              Refuser
            </button>
            <Link to="/politique-confidentialite" className="ml-auto text-xs text-bati-ink/50 underline underline-offset-4 hover:text-bati-sky">
              En savoir plus
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
